export default __webpack_public_path__ + "static/media/pokebola.1e479e0a.png";